import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Facebook, Heart, MessageCircle, Share2, Hash } from 'lucide-react';
import u18f from '../../assets/efafc_u18f.jpg';
import r1 from '../../assets/efafc_r1.jpg';
import u16 from '../../assets/efafc_u16.jpg';
import u13 from '../../assets/efafc_u13_2.jpg';
import u11 from '../../assets/efafc_u11.jpg';
import u10 from '../../assets/efafc_u10.jpg';

const posts = [
    { id: 1, image: u18f, likes: 124, comments: 12, type: 'instagram', span: 'col-span-1 row-span-1' },
    { id: 2, image: r1, likes: 256, comments: 45, type: 'facebook', span: 'col-span-1 row-span-2' },
    { id: 3, image: u16, likes: 89, comments: 5, type: 'instagram', span: 'col-span-1 row-span-1' },
    { id: 4, image: u13, likes: 156, comments: 23, type: 'instagram', span: 'col-span-1 row-span-1' },
    { id: 5, image: u11, likes: 67, comments: 8, type: 'facebook', span: 'col-span-1 row-span-1' },
    { id: 6, image: u10, likes: 112, comments: 18, type: 'instagram', span: 'col-span-1 row-span-1' },
];

export default function SocialWall() {
    return (
        <section className="w-full py-16">
            <div className="container mx-auto px-4">

                {/* Header */}
                <div className="text-center mb-12">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-gray-100 text-efafcDark rounded-full font-bold text-sm mb-4">
                        <Hash size={16} />
                        SOCIAL MEDIA
                    </div>
                    <h2 className="text-3xl md:text-4xl font-title font-bold text-efafcDark mb-6">
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-efafcBlue to-efafcGreen">SUIVEZ L'ACTUALITÉ DU CLUB</span>
                    </h2>
                    <div className="flex flex-wrap items-center justify-center gap-4">
                        <a
                            href="https://www.instagram.com/efafc_officiel/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 px-6 py-3 bg-efafcDark text-white rounded-xl font-bold hover:bg-efafcBlue transition-all transform hover:-translate-y-1 shadow-lg shadow-efafcBlue/20"
                        >
                            <Instagram size={20} className="text-efafcYellow" />
                            @efafc_officiel
                        </a>
                        <a
                            href="https://www.facebook.com/EntenteFeigniesAulnoye"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 px-6 py-3 bg-white border-2 border-efafcDark text-efafcDark rounded-xl font-bold hover:bg-gray-50 transition-all transform hover:-translate-y-1"
                        >
                            <Facebook size={20} className="text-efafcBlue" />
                            Entente Feignies Aulnoye
                        </a>
                    </div>
                </div>

                {/* Masonry Grid */}
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 auto-rows-[200px]">
                    {posts.map((post, index) => (
                        <motion.div
                            key={post.id}
                            className={`relative group overflow-hidden rounded-2xl cursor-pointer ${post.span}`}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.1 }}
                        >
                            <img
                                src={post.image}
                                alt="Social Post"
                                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />

                            {/* Overlay */}
                            <div className="absolute inset-0 bg-gradient-to-t from-efafcDark/90 via-efafcDark/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                                <div className="absolute top-4 right-4 bg-white/10 backdrop-blur-md p-2 rounded-full">
                                    {post.type === 'instagram' ? (
                                        <Instagram className="text-white" size={18} />
                                    ) : (
                                        <Facebook className="text-white" size={18} />
                                    )}
                                </div>

                                <div className="flex items-center gap-4 text-white translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                                    <div className="flex items-center gap-1.5">
                                        <Heart size={16} className="fill-efafcYellow text-efafcYellow" />
                                        <span className="text-sm font-bold">{post.likes}</span>
                                    </div>
                                    <div className="flex items-center gap-1.5">
                                        <MessageCircle size={16} className="fill-white text-white" />
                                        <span className="text-sm font-bold">{post.comments}</span>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>

            </div>
        </section>
    );
}
